import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { comparisonRows, planIncludes } from '../../data/landing';
export function PlanMaestro() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-218" data-mp="ewht7h4sb9g5">
      <div className="mx-auto max-w-5xl" data-id="element-219" data-mp="etvix9qiefu8">
        <SectionHeading title="¿Por Qué agregar el Plan Maestro (30 días)?" data-id="element-220" data-mp="ju059ge3m4sd" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-line bg-white" data-id="element-221" data-mp="17knec4zr30gi">
          <div className="hidden grid-cols-[1.1fr_1fr_1fr] border-b border-line text-sm font-black uppercase tracking-wider md:grid" data-id="element-222" data-mp="1cjgopojqqbcg">
            <div className="px-6 py-4 text-muted" data-id="element-223" data-mp="xl69fpsboqll">Situación</div>
            <div className="flex items-center gap-2 bg-danger-soft px-6 py-4 text-danger" data-id="element-224" data-mp="12latfpsfw3gk">
              <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-225" data-mp="3icf27mr7mbcw" /> Sin Plan Maestro
            </div>
            <div className="flex items-center gap-2 bg-brand px-6 py-4 text-white" data-id="element-226" data-mp="3nb9xvpa9zuef">
              <CheckIcon className="h-4 w-4 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-227" data-mp="1tdeey2bzonig" /> Con Plan Maestro
            </div>
          </div>
          <ul className="divide-y divide-line" data-id="element-228" data-mp="1ofcy7o21d0a5">
            {comparisonRows.map(r => <li key={r.situation} className="grid md:grid-cols-[1.1fr_1fr_1fr]" data-id="element-229" data-mp="22dudcxdvl4gg">
                <div className="px-6 pb-2 pt-5 text-base font-extrabold text-brand md:py-5" data-id="element-230" data-mp="1xezn5adkwdmb">
                  {r.situation}
                </div>
                <div className="flex items-start gap-2 px-6 py-2 text-sm text-charcoal md:bg-danger-soft/50 md:py-5 md:text-base" data-id="element-231" data-mp="2caz5reybdw5p">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger md:hidden" strokeWidth={3} aria-hidden="true" data-id="element-232" data-mp="27b2z17y8fqmg" />
                  <span className="sr-only" data-id="element-233" data-mp="2h2yyamc21ms9">Sin Plan Maestro: </span>
                  {r.without}
                </div>
                <div className="flex items-start gap-2 bg-brand-soft px-6 pb-5 pt-2 text-sm font-semibold text-brand md:py-5 md:text-base" data-id="element-234" data-mp="2v28gfrjtmqyv">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand md:hidden" strokeWidth={3} aria-hidden="true" data-id="element-235" data-mp="2q58634fxv21y" />
                  <span className="sr-only" data-id="element-236" data-mp="1nofs9cb28sjn">Con Plan Maestro: </span>
                  {r.with}
                </div>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 rounded-3xl bg-brand-soft p-7 md:p-10" data-id="element-237" data-mp="1wq5m0osf03kl">
          <h3 className="text-xl font-extrabold text-brand" data-id="element-238" data-mp="21i710igyw8eb">El Plan Maestro incluye:</h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-239" data-mp="26h0g2fbwk7gl">
            {planIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-charcoal" data-id="element-240" data-mp="2bftk7h5aum43">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-241" data-mp="2bhoa79vfh4f1">
                  <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-242" data-mp="2kgjcwbz9jwdl" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}